import React, {useRef, useState} from 'react';

import {EntityMegaHeaderModuleProps} from "../models/entity-mega-header-module.props";
import {Compose, ComposeSettings} from "../../../../../core/components/composers/compose";
import {EntityMegaHeaderModuleController} from "../entity-mega-header-module.controller";
import classNames from "classnames";
import styles from "../styles/entity-mega-header-module.module.scss";
import {EntityMegaHeaderModuleLogo} from "./entity-mega-header-module.logo";
import {EntityMegaHeaderModuleTitle} from "./entity-mega-header-module.title";
import {EntityMegaHeaderModuleNavigationBar} from "./entity-mega-header-module.navigation-bar";
import useOverflowDetection from "../../../../../infrastructure/hooks/useOverflowDetection";

export class EntityMegaHeaderModuleComponentProps extends EntityMegaHeaderModuleProps {}

export const EntityMegaHeaderModuleComponent = (({controller, entity, tabsContext, descriptionHeader}: EntityMegaHeaderModuleComponentProps) => {
  const {device} = controller;
  const {isSmallView} = device;

  const contentRef = useRef(null);
  const [isWideContainer, setIsWideContainer] = useState(false);

  useOverflowDetection(contentRef, isSmallView, setIsWideContainer);

  const baseProps = {
    controller,
    entity
  }

  const titleProps = {
    ...baseProps,
    descriptionHeader
  }

  const navigationBarProps = {
    entity,
    tabsContext
  }

  const contentProps = {
    ref: contentRef,
    className: classNames(styles.content, {[styles.wide_content]: isWideContainer})
  }

  return (
    <div className={classNames(styles.container, {[styles.small_view]: isSmallView})}>
      <div {...contentProps}>
        <EntityMegaHeaderModuleLogo {...baseProps}/>
        <EntityMegaHeaderModuleTitle {...titleProps}/>
        <EntityMegaHeaderModuleNavigationBar {...navigationBarProps}/>
      </div>
    </div>
  )
});

const settings: ComposeSettings = {
  component: EntityMegaHeaderModuleComponent,

  observe: true,
  injectData: true,
  createModule: true,
  propsType: EntityMegaHeaderModuleComponentProps,
  controllerType: EntityMegaHeaderModuleController
};

export default Compose(settings);
